<app-header></app-header>
<app-aside></app-aside>

<div id="content-wrapper">
    <router-outlet></router-outlet>
</div>
